import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum AgentUsageColumn {
    CLIENT = "client",
    LAST_ACTIVITY = "lastActivity",
    FREE_TOKENS = "freeTokens",
    PAID_TOKENS = "paidTokens",
    SHARE_OF_USAGE = "shareOfUsage",
    TASKS = "tasks",
}

const ClientColumnSchema = ColumnSchema.extend({
    id: z.literal(AgentUsageColumn.CLIENT),
});
const LastActivityColumnSchema = ColumnSchema.extend({
    id: z.literal(AgentUsageColumn.LAST_ACTIVITY),
});
const FreeTokensColumnSchema = ColumnSchema.extend({
    id: z.literal(AgentUsageColumn.FREE_TOKENS),
});
const PaidTokensColumnSchema = ColumnSchema.extend({
    id: z.literal(AgentUsageColumn.PAID_TOKENS),
});
const ShareOfUsageColumnSchema = ColumnSchema.extend({
    id: z.literal(AgentUsageColumn.SHARE_OF_USAGE),
});
const TasksColumnSchema = ColumnSchema.extend({
    id: z.literal(AgentUsageColumn.TASKS),
});

export const AgentUsageViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.AGENT_USAGE),
    columns: z.array(
        z.discriminatedUnion("id", [
            ClientColumnSchema,
            LastActivityColumnSchema,
            FreeTokensColumnSchema,
            PaidTokensColumnSchema,
            ShareOfUsageColumnSchema,
            TasksColumnSchema,
        ]),
    ),
});

export type AgentUsageView = z.infer<typeof AgentUsageViewSchema>;
